import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';

@Injectable({
	providedIn: 'root',
})
export class CalendarEventReservationsProvider extends Provider<any> {
	protected readonly url: string = '/calendar-events';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public reserve(id: string): Promise<any> {
		return this.process(this.api.post(`${this.url}/${id}/reservations`, id)) as any as Promise<any>;
	}

	public release(): void {
		this.process(this.api.delete(`${this.url}/reservations`), false);
	}
}
